import { createApiService } from "@/core/api/apiService";
import type {
  CreateMessageDto,
  MessageDto,
  UpdateMessageDto,
} from "../types/messageTypes";

export function createMessageApiClient() {
  const api = createApiService("messages");

  return {
    getList: async (params?: {
      businessId?: string;
      conversationId?: string;
      phoneNumberId?: string;
    }, signal?: AbortSignal): Promise<MessageDto[]> => {
      const queryParams = new URLSearchParams();
      if (params?.businessId) queryParams.set("businessId", params.businessId);
      if (params?.conversationId)
        queryParams.set("conversationId", params.conversationId);
      if (params?.phoneNumberId)
        queryParams.set("phoneNumberId", params.phoneNumberId);

      const query = queryParams.toString();
      return api.get<MessageDto[]>(query ? `/?${query}` : "/", { signal });
    },

    getById: async (id: string, signal?: AbortSignal): Promise<MessageDto> => {
      return api.get<MessageDto>(`/${id}`, { signal });
    },

    create: async (data: CreateMessageDto, idempotencyKey: string): Promise<MessageDto> => {
      return api.post<MessageDto>("", data, {
        headers: { "Idempotency-Key": idempotencyKey },
      });
    },

    update: async (id: string, data: UpdateMessageDto): Promise<MessageDto> => {
      return api.put<MessageDto>(`/${id}`, data);
    },

    delete: async (id: string): Promise<{ message: string }> => {
      return api.delete<{ message: string }>(`/${id}`);
    },
  };
}

const messageApiService = createMessageApiClient();
export { messageApiService };
